import { useId, type ComponentPropsWithRef } from 'react'

export interface ColorInputProps extends Omit<
    ComponentPropsWithRef<'input'>,
    'type' | 'value' | 'defaultValue'
> {
    defaultValue?: string | null
}

export function ColorInput({
    defaultValue,
    id,
    name,
    disabled = false,
    className = '',
    ...inputProps
}: ColorInputProps) {
    const generatedId = useId()
    const inputId = id ?? (name ? name : generatedId)

    const defaultColorValue =
        defaultValue !== undefined ? (defaultValue ?? '#000000') : undefined

    const stateClasses = disabled
        ? 'bg-stone-100 text-gray-500 focus:border-stone-200 select-none cursor-not-allowed'
        : 'bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary'

    return (
        <input
            {...inputProps}
            id={inputId}
            name={name}
            type="color"
            defaultValue={defaultColorValue}
            disabled={disabled}
            className={`p-1 h-10.5 w-full block border border-stone-200 shadow-xs rounded-lg2 ${stateClasses} ${className}`.trim()}
        />
    )
}
